<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="16" :md="16">
                <el-input v-model="filtro.nome" placeholder="Pesquisar instituicao..." @keyup.native.enter="loadingInstituicoes"></el-input>
            </el-col>
            <el-col v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6" :xs="24" :sm="8" :md="8" class="u-text-right">
                <router-link to="/admin/instituicao/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVA INSTITUIÇÃO</el-button>
                </router-link>
            </el-col>
        </el-row>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Nome</th>                        
                        <th>Bairro</th>
                        <th>Situação</th>
                        <th v-if="$store.state.user.tipo < 7" style="width: 70px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.nome | truncate(70, '...') }}</td>
                        <td>{{ item.bairro | truncate(30, '...') }}</td>
                        <td>{{ $CONSTANTS.SITUACAO_FUNCIONAMENTO[item.situacao_funcionamento] }}</td>
                        <td v-if="$store.state.user.tipo < 7" class="u-text-center acao">
                            <router-link :to="'instituicao/edit/' + item.id" class="link-icon" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>        
    </div>
</template>
<script>

export default {
    data: () => ({
        dialogInfoInstituicao: false,
        statusList: false,
        filtro: {
            nome: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ],
        info: { id: '1' }
    }),
    mounted () {
      this.loadingInstituicoes()
    },
    methods: {
        loadingInstituicoes(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteInstituicao(id){

            this.$msgbox.confirm('Só é permitido excluir uma instituição, se não existirem vinculos com a mesma. Tem certeza que deseja continuar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/instituicao/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingInstituicoes();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingInstituicoes();
        }        
    },
    components:{  }
}
</script>